import { Pipe, PipeTransform } from '@angular/core';

import { capitalize } from '../../core/utils/string.utils';

@Pipe({
  name: 'capitalize'
})
export class CapitalizePipe implements PipeTransform {
  transform(value: string): string {
    return capitalize(value);
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/shared/pipes/capitalize.pipe.ts